import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import lang from '@/lang'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { nextStep } from '@/redux/ducks/wizard/config'
import { ButtonSquare } from '@/modules/base/components/buttons'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'
import RegistrationStepCard from './components/registration-step-card'
import AvvConsent from './components/avv-consent'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  nextButton: {
    height: 48,
    borderRadius: theme.borderRadiusPill,
    fontSize: theme.fontSizes.smedium,
  },
}))

// same label as the AVV step of the old onboarding, so the tracking stays comparable
const eventOmo = 'Avv/Agb'

// takes the place of the password step (2 of 3) when the user already has a password,
// e.g. after setting one via "Passwort vergessen" before finishing the registration
const REGISTRATION_STEP = 2

/**
 * orgaMAX registration step for users with a password: AVV consent, then the short question.
 */
const OnboardingAvvConsent = () => {
  const classes = useStyles()
  const dispatch = useAppDispatch()
  const { step, totalSteps } = useAppSelector(state => state.wizard.config)
  const subscriptions = useAppSelector(state => state.tenant.info.subscriptions)
  const userInfo = useAppSelector(state => state.user.info)
  const subscriptionTypeTypesLabel = subscriptions?.map(s => s.typeOfSubscription).join(', ') || ''
  const [avvInputsValid, setAvvInputsValid] = useState(false)
  // "Weiter" is always active - after a click a missing consent is named
  const [isSubmitted, setIsSubmitted] = useState(false)

  const next = () => {
    setIsSubmitted(true)
    if (!avvInputsValid) return
    GtmService.pushEvent({
      event: GtmEventTypes.GaEventHub,
      eventCategory: 'Onboarding',
      eventAction: 'Weiter',
      email: userInfo?.email || '',
      eventLabel: `${eventOmo} abgeschlossen ${subscriptionTypeTypesLabel} (${step}/${totalSteps})`,
    })
    dispatch(nextStep())
  }

  return (
    <RegistrationStepCard
      step={REGISTRATION_STEP}
      title={lang.onboardingV2.avv.title}
      text={lang.onboardingV2.avv.text}
      dataQsId='onboarding-avv-consent'
      stickyFooter
      footer={(
        <ButtonSquare
          className={classes.nextButton}
          label={lang.registration.password.next}
          onClick={next}
          dataQsId='onboarding-avv-consent-next'
        />
      )}
    >
      <AvvConsent setInputsValid={setAvvInputsValid} showError={isSubmitted} dataQsId='onboarding-avv' />
    </RegistrationStepCard>
  )
}

export default OnboardingAvvConsent
